var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarSummaryTransavia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.8242046px",
    height: "16px",
    viewBox: "0 0 16.8242046 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star_transavia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShoppingCart",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoppingcart/Icons/Checkout/Insurance",
    transform: "translate(-16.000000, -162.000000)",
    fill: "#F9BF71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star_transavia",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon",
    points: "8.41210232 0 10.3972224 6.1106781 16.8242046 6.1106781 11.6250266 9.8881882 13.6112804 16 8.41210232 12.2224899 3.21292425 16 5.19917806 9.8881882 -8.3593263e-16 6.1106781 6.42584851 6.1106781 8.41210232 0"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSummaryTransavia);
export default __webpack_public_path__ + "static/media/star-summary-transavia.1f7edfa363a0a8537dcaef89c875e05f.svg";
export { ForwardRef as ReactComponent };